import { useMsal } from "@azure/msal-react";
import React, { memo, useEffect } from "react";
import { useDispatch } from "react-redux";
import PuiButton from "../../../../components/elements/PuiButton";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import { SetSessionTimeout } from "../../../../user/UserActions";

function SessionTimeout() {
    const { instance } = useMsal();
    const dispatch = useDispatch();

    // ログイン画面に戻る処理
    const Logout = () => {
        localStorage.clear();
        instance.logout();
    };

    useEffect(() => {
        dispatch(SetSessionTimeout());
        localStorage.setItem("isSessionTimeout", "true");
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                <div
                    style={{
                        color: "white",
                        textAlign: "center",
                        width: "100%",
                    }}
                >
                    このセッションの有効期限が切れました。
                    {!IsDevice("desktop") && <br />}
                    「ログイン画面に戻る」ボタンをクリックしてサインインし直してください。
                </div>
                <div
                    style={{
                        width: "250px",
                        height: "50px",
                        textAlign: "center",
                        marginTop: "30px",
                    }}
                >
                    <PuiButton onClick={Logout}>ログイン画面に戻る</PuiButton>
                </div>
            </div>
        </>
    );
}
export default memo(SessionTimeout);
